import { Injectable } from '@angular/core';
import { PaymentType } from '@spartacus/cart/base/root';
import { CheckoutPaymentTypeConnector } from '@spartacus/checkout/b2b/core';
import { Observable } from 'rxjs';
import { CreditCard, Payments } from 'src/app/spartacus/custom/cms-components/checkout/components/custom-credit-card/store/credit-card.state';
import { CustomPaymentTypeAdapter } from './custom-payment-type.adapter';

@Injectable({
  providedIn: 'root',
})
export class CustomPaymentTypeConnector extends CheckoutPaymentTypeConnector {
  constructor(
    protected adapter: CustomPaymentTypeAdapter
  ) {
    super(adapter);
  }

  public getPaymentTypes(): Observable<PaymentType[]> {
    return this.adapter.getPaymentTypes();
  }

  public creditCardList(
    userId: string,
  ): Observable<Payments> {
    return this.adapter.creditCardList(userId);
  }

  public getSelectedCreditCard(
    userId: string,
    creditCardDetail: CreditCard
  ): Observable<CreditCard> {
    return this.adapter.getSelectedCreditCard(userId, creditCardDetail.id);
  }

  public setSelectedCreditCard(
    userId: string,
    cartId: string,
    paymentDetailsId: string
  ): Observable<CreditCard> {
    return this.adapter.setSelectedCreditCard(userId, cartId, paymentDetailsId);
  }

  public removeSelectedCreditCard(
    userId: string,
    paymentDetailsId: string,
  ): Observable<CreditCard> {
    return this.adapter.removeSelectedCreditCard(userId, paymentDetailsId);
  }
}
